import { Icon } from "components/icon/Icon"
import { useDictionary } from "contexts/Dictionary"
import {
  ListRoot,
  ListWrapper,
  TitleRow,
  TitleLine,
  ClearHistoryButton,
  InnerList,
  FlexLi,
  ResultLine,
  ScreenReaderDiv,
} from "./styles"

const listVariants = {
  hidden: { height: 0 },
  visible: {
    height: "auto",
    transition: { staggerChildren: 0.07 },
  },
}

const itemVariants = {
  hidden: { opacity: 0, x: -10 },
  visible: { opacity: 1, x: 0 },
}

export default function RecentlySearched({ searchList, onSelect, onClear }) {
  const dictionary = useDictionary()

  if (!searchList?.length) return null

  return (
    <ListRoot initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: "auto" }} exit={{ opacity: 0, height: 0, overflow: "hidden" }}>
      <ListWrapper>
        <TitleRow>
          <TitleLine id="recentlySearchLabel" variants={itemVariants}>
            {dictionary.recentlySearch()}
          </TitleLine>
          <ClearHistoryButton type="button" onClickCapture={onClear} aria-label={dictionary.clear()}>
            {dictionary.clear()}
            <span>
              <Icon type="close" viewBox="0 0 15 15" />
            </span>
          </ClearHistoryButton>
        </TitleRow>
        <ScreenReaderDiv aria-live="polite" className="sr-only">
          {`${searchList.length} ${dictionary.ariaLiveRecentlySearch()}`}
        </ScreenReaderDiv>
        <InnerList initial="hidden" animate="visible" variants={listVariants} aria-labelledby="recentlySearchLabel">
          {searchList.map((item, i) => (
            <FlexLi key={i} variants={itemVariants}>
              <ResultLine type="button" onClick={() => onSelect(item)}>
                {item}
              </ResultLine>
            </FlexLi>
          ))}
        </InnerList>
      </ListWrapper>
    </ListRoot>
  )
}
